import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { APIManagerConfig } from '../apiManager';
import { FeedingListPreset, Preset, PresetSettings } from './preset.types';

const PresetServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getPresetList: (reportType: string): Promise<Preset[]> =>
      HTTPBase.get(`farm/${config.farmId}/reports/${reportType}/presets`).then((res) => res.data),
    createPreset: (
      reportType: string,
      name: string | undefined,
      preset: PresetSettings,
      formName: FormName,
    ): Promise<Preset> =>
      HTTPBase.post(
        `farm/${config.farmId}/reports/${reportType}/presets`,
        { ...preset, name },
        { headers: { formName } },
      ).then((res) => res.data),
    updatePreset: (reportType: string, preset: Preset, formName: FormName): Promise<Preset> =>
      HTTPBase.patch(
        `farm/${config.farmId}/reports/${reportType}/presets/${preset.id}`,
        { ...preset },
        { headers: { formName } },
      ).then((res) => res.data),
    deletePreset: (reportType: string, presetId: Preset['id'], formName: FormName): Promise<Preset> =>
      HTTPBase.delete(`farm/${config.farmId}/reports/${reportType}/presets/${presetId}`, {
        headers: { formName },
      }).then((res) => res.data),
    createFeedingListPreset: (preset: Preset, formName: FormName): Promise<Preset> =>
      HTTPBase.post(`farm/${config.farmId}/feedings/presets`, { ...preset }, { headers: { formName } }).then(
        (res) => res.data,
      ),
    updateFeedingListPreset: (preset: FeedingListPreset, formName: FormName): Promise<Preset> =>
      HTTPBase.patch(
        `farm/${config.farmId}/feedings/presets/${preset.id}`,
        { ...preset },
        { headers: { formName } },
      ).then((res) => res.data),
    createRefusalsPreset: (preset: Preset, formName: FormName): Promise<Preset> =>
      HTTPBase.post(`farm/${config.farmId}/refusals/presets`, { ...preset }, { headers: { formName } }).then(
        (res) => res.data,
      ),
    updateRefusalsPreset: (preset: Preset, formName: FormName): Promise<Preset> =>
      HTTPBase.patch(
        `farm/${config.farmId}/refusals/presets/${preset.id}`,
        { ...preset },
        { headers: { formName } },
      ).then((res) => res.data),
    createStockTransactionsPreset: (preset: Preset, formName: FormName): Promise<Preset> =>
      HTTPBase.post(
        `farm/${config.farmId}/reports/stocktransaction/presets`,
        { ...preset },
        { headers: { formName } },
      ).then((res) => res.data),
    updateStockTransactionsPreset: (preset: FeedingListPreset, formName: FormName): Promise<Preset> =>
      HTTPBase.patch(
        `farm/${config.farmId}/reports/stocktransaction/presets/${preset.id}`,
        { ...preset },
        { headers: { formName } },
      ).then((res) => res.data),
  };
};

export default PresetServiceFactory;
